import { type OrderStatus } from "~/gql/graphqlBase.generated";
import { formatStatusLabel } from "~/helpers/statusChip";

export const getStatusLabel = (status: OrderStatus | null | undefined): string => formatStatusLabel(status);

export default getStatusLabel;
